import { createContext, useContext } from 'react';

const VouchManager = createContext({
  selectedContact: null,
  selectedUser: null,
  selectedJob: null,
  selectedRelation: null,
  onSelectJob: () => {},
  onSelectUser: () => {},
  onSelectRelation: () => {},
  onAddVouchNote: () => {},
});

VouchManager.displayName = 'VouchManager';

export const useVouchManager = () => {
  const vouchManager = useContext(VouchManager);
  return vouchManager;
};

export const VouchProvider = VouchManager.Provider;
